import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class SpecificDistributionAllocationType extends Enum {
  static AMOUNT = {
    key: 'amount',
    get value() {
      return Lang.t('accruedinterest.amount');
    }
  };

  static ASSET = {
    key: 'asset',
    get value() {
      return Lang.t('accounting.asset');
    }
  };
}
